<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button  @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back" :disabled="backButtonStatus"/>
          <action-button  @click="save" icon="save" bold :text="lang.button_Save" :tooltip="lang.button_Save" :disabled="saveButtonStatus"/>



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold :text="lang.button_Left" :title="lang.button_Left" :disabled="false"/>
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold :text="lang.button_Right" :title="lang.button_Right" :disabled="false"/>

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/LibraryManager/Views/LibraryDerive/Middle/Content/Content"



export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },
  data () {
    return {

      saveButtonStatus: false,
      backButtonStatus: false,
      saving: false,
    }
  },
  computed:{
    

  },
  created() {


  },
  methods: {
    save(){
      


        let trig = false;
        for (let i = 0, lei = this.$store.getters.propertyToSaving.length; i < lei; i++){
                

          if ((this.$store.getters.propertyToSaving[i].isRequiredOnRequest == true)&&(this.$store.getters.propertyToSaving[i].value == "")){
            trig = true;
            break;
          }
        }

        if (trig == true){
          let obj = {
            text: this.lang.alert_error_new_library_required,
            time: 10,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);
        }else{

          

          let obj = {
            categoryId: this.$store.getters.selectedTreeLibraryItemObject.categoryId,
            libraryRevisionId: this.$route.query.revisionId,
            values: this.$store.getters.propertyToSaving,
            
          }

          let vue = this;
          
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_deriveLibrary", obj)
          .then(function(result){

            console.log(result.data)

            

            if (result.status == "OK"){

              if (result.data != null){
                vue.saving = true;

                const obj = {
                  text: vue.lang.alert_success_derive,
                  time: 10,
                  type: "success"
                }

                vue.$store.dispatch("displayFooterAlert", obj);

                vue.toDetails(result.data);
              }else{

                const obj = {
                  text: vue.lang.alert_error_derive + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

                vue.$store.dispatch("displayFooterAlert", obj);

              }

              


            }else{
              const obj = {
                text: vue.lang.alert_error_derive + ": " + result.message,
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

          }


    },
    toDetails(goalObj){
      this.$store.dispatch("resetPropertyToSaving");

      this.$store.dispatch("deleteAllSelectedRows");

      let to = "/LibraryManager/LibraryDetails";

      const obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: 1
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: "pendingNew"
            }
            
          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.libraryNumber
            }
            
          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: ""
            }
          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.libraryType
            }
          }
        }

      this.$store.dispatch("setSelectedRows", [obj]);
      
      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      
      

      const query = {
        from: this.$route.path,
        to: to,
        revisionId: goalObj.revisionId,
        id: goalObj.libraryId
      }

      this.$router.push({ path: to, query: query });

          

    },
    back(){
      
      this.$store.dispatch("setSaveStatus", false);
      this.$store.dispatch("resetPropertyToSaving");

      if (this.saving){
        
        const reloadObj = {
            status: true,
            name: "DataTableFilteredOnApiLibComponent"
        }
        this.$store.dispatch("reloadAfterAction", reloadObj);
        

      }
      let to = this.$route.query.from;

      
      const query = {
        from: this.$route.path,
        to: to,
        revisionId: this.$route.query.revisionId,
        id: this.$route.query.id
      }

      this.$router.push({ path: to, query: query });

      
    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryDerive/Middle/Middle.vue